import { NavLink } from "react-router-dom";

const TimesheetNavBar = () => {
  return (
		<nav>
			<ul>
				<li><NavLink to="/addTime">Add Timesheet</NavLink></li>
				<li><NavLink to="/editTime">Edit Timesheet</NavLink></li>
				<li><NavLink to="/deleteTime">Delete Timesheet</NavLink></li>
			</ul>
		</nav>
	);
};

export default TimesheetNavBar;
